import type { AIModelChoices, Annotation } from 'api';
import { Box, ColorLegendItem, useBreakpoint } from 'ui';

import {
  type GroupedAnnotation,
  getGroupedAnnotations,
  isGroupHidden,
} from '../../utils/formatAnnotations/formatAnnotations';

export const SegmentationLegend = ({
  annotations,
  hiddenCategories,
  onSelectCategory,
  model,
  showAerosols = false,
}: {
  annotations: Annotation[];
  hiddenCategories: readonly string[];
  onSelectCategory: (label: string) => void;
  model: AIModelChoices;
  showAerosols?: boolean;
}) => {
  const { isMobile } = useBreakpoint();
  const groupedAnnotations = getGroupedAnnotations(annotations, model, showAerosols);

  const handleGroupClick = (groupedItem: GroupedAnnotation) => {
    const isHidden = isGroupHidden(groupedItem, hiddenCategories);

    for (const label of groupedItem.originalLabels) {
      const isLabelCurrentlyHidden = hiddenCategories.includes(label);

      if ((isHidden && isLabelCurrentlyHidden) || (!isHidden && !isLabelCurrentlyHidden)) {
        onSelectCategory(label);
      }
    }
  };

  return (
    <Box
      data-testid="segmentation-legend"
      sx={{
        display: 'flex',
        flexDirection: isMobile ? 'row' : 'column',
        gap: 1,
        justifyContent: isMobile ? 'flex-start' : 'center',
        overflow: 'auto',
      }}
    >
      {groupedAnnotations.map((group) => (
        <ColorLegendItem
          key={group.groupName}
          label={group.groupName}
          color={[...group.colour]}
          hidden={isGroupHidden(group, hiddenCategories)}
          handleClick={() => handleGroupClick(group)}
        />
      ))}
    </Box>
  );
};
